export type FeatureFromGeojson = {
  type: "Feature";
  id: string;
  geometry: any;
  properties: Record<string, any>;
};

export type FeatureCollection = {
  type: "FeatureCollection";
  features: FeatureFromGeojson[];
};

/**
 * 기존 피처의 선택/수정/이동 상태를 불변적으로 초기화하고 새 피처를 추가합니다.
 */
export function computeAddGeoJson(
  currentFeatures: FeatureFromGeojson[],
  newFeature: FeatureFromGeojson
): FeatureCollection {
  const unSelectedFeatures = currentFeatures.map((feature) => ({
    ...feature,
    properties: {
      ...feature.properties,
      isSelected: false,
      isModifying: false,
      isMoving: false,
    },
  }));
  return {
    type: "FeatureCollection",
    features: [...unSelectedFeatures, newFeature],
  };
}

/**
 * 대상 피처의 properties를 불변적으로 merge합니다.
 */
export function computeUpdateGeoJson(
  currentFeatures: FeatureFromGeojson[],
  id: string,
  updatedGeoJson: Omit<FeatureFromGeojson, "id">
): FeatureCollection {
  const filtered = currentFeatures.filter((feature) => feature.id !== id);
  const target = currentFeatures.find((feature) => feature.id === id)!;
  const updated: FeatureFromGeojson = {
    ...updatedGeoJson,
    id,
    properties: { ...target.properties, ...updatedGeoJson.properties },
  };
  return {
    type: "FeatureCollection",
    features: [...filtered, updated],
  };
}
